const NotificationSkeleton = () => (
  <div className="bg-skeleton-primary h-[80px] w-full animate-pulse rounded-sm" />
)

const NotificationsListSkeleton = () => (
  <div className="bg-background-secondary flex w-full flex-col items-center justify-center gap-3 px-6 py-4">
    <NotificationSkeleton />
    <NotificationSkeleton />
    <NotificationSkeleton />
  </div>
)

export default NotificationsListSkeleton
